import * as Sentry from "@sentry/nextjs";

/**
 * Check if we're in production environment
 */
const isProduction = () => process.env.NODE_ENV === "production";

export interface SentryUserContext {
    id: string;
    username?: string;
    email?: string;
    role: "host" | "player";
}

export interface SentryHostContext {
    hostUsername: string;
}

/**
 * Set user context in Sentry for error tracking
 */
export const setSentryUser = (user: SentryUserContext) => {
    // Only set Sentry context in production
    if (!isProduction()) {
        console.log("🔄 [DEV] Sentry user context would be set:", user);

        return;
    }

    Sentry.setUser({
        id: user.id,
        username: user.username,
        email: user.email,
        role: user.role
    });

    Sentry.setTag("user_role", user.role);
    Sentry.setTag("auth_provider", user.role === "host" ? "credentials-login" : "credentials-player-login");
};

/**
 * Set host context in Sentry for player tracking
 */
export const setSentryHostContext = (hostContext: SentryHostContext) => {
    // Only set Sentry context in production
    if (!isProduction()) {
        console.log("🔄 [DEV] Sentry host context would be set:", hostContext);

        return;
    }

    Sentry.setTag("host_username", hostContext.hostUsername);
};

/**
 * Clear Sentry user context (useful for logout)
 */
export const clearSentryUser = () => {
    // Only clear Sentry context in production
    if (!isProduction()) {
        console.log("🔄 [DEV] Sentry user context would be cleared");

        return;
    }

    Sentry.setUser(null);
    Sentry.setTag("user_role", undefined);
    Sentry.setTag("auth_provider", undefined);
    Sentry.setTag("host_username", undefined);
};
